module.exports = __webpack_public_path__ + "img/il.c8ab8be1.svg";